import { gql } from "@apollo/client";

import { FAMILY_FIELDS } from "@/graphql/queries/family";

/**
 * `acceptUrl` comes back always, and that is the point: an instance with no SMTP
 * configured, a bounce or a spam folder must not be the only way an invitation
 * reaches anybody. `emailed` says whether the mail actually went out, so the
 * screen can promise what happened rather than what was intended.
 */
export const CREATE_FAMILY_INVITATION = gql`
  mutation CreateFamilyInvitation($email: String!) {
    createFamilyInvitation(email: $email) {
      errors
      acceptUrl
      emailed
      family {
        ...FamilyFields
      }
    }
  }
  ${FAMILY_FIELDS}
`;

export const REVOKE_FAMILY_INVITATION = gql`
  mutation RevokeFamilyInvitation($id: ID!) {
    revokeFamilyInvitation(id: $id) {
      errors
      family {
        ...FamilyFields
      }
    }
  }
  ${FAMILY_FIELDS}
`;

export const ACCEPT_FAMILY_INVITATION = gql`
  mutation AcceptFamilyInvitation($token: String!) {
    acceptFamilyInvitation(token: $token) {
      errors
      family {
        ...FamilyFields
      }
    }
  }
  ${FAMILY_FIELDS}
`;

export const REMOVE_FAMILY_MEMBER = gql`
  mutation RemoveFamilyMember($studentId: ID!) {
    removeFamilyMember(studentId: $studentId) {
      errors
      family {
        ...FamilyFields
      }
    }
  }
  ${FAMILY_FIELDS}
`;

export const LEAVE_FAMILY = gql`
  mutation LeaveFamily {
    leaveFamily {
      errors
      family {
        ...FamilyFields
      }
    }
  }
  ${FAMILY_FIELDS}
`;

export const TRANSFER_FAMILY_OWNERSHIP = gql`
  mutation TransferFamilyOwnership($studentId: ID!) {
    transferFamilyOwnership(studentId: $studentId) {
      errors
      family {
        ...FamilyFields
      }
    }
  }
  ${FAMILY_FIELDS}
`;

export const RENAME_FAMILY = gql`
  mutation RenameFamily($name: String!) {
    renameFamily(name: $name) {
      errors
      family {
        ...FamilyFields
      }
    }
  }
  ${FAMILY_FIELDS}
`;
